<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-25 09:56:34
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveCanaelReason\newLeaveCanaelReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-23 17:44:53
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveCancelReason_from_newTitle')"
    widthClass="max-1000"
    :initData="leaveCancelData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'leave_reason_name',
      'leave_reason_code',
      'leave_reason_description',
      'sequence',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-container fluid class="pa-0">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <inputTextFiledMultiLang
                :bindData="leaveCancelData.leave_reason_name"
                maxlength="100"
                @change="
                  (valueArr) => {
                    leaveCancelData.leave_reason_name = valueArr;
                  }
                "
                :label="
                  $t(
                    'label_essweb_leaveCancelReason_from_leaveCancelReasonNameLabel'
                  )
                "
                :rules="$GetRules(['_Require_Rules'], [null])"
              />
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <normalInputTextFiled
                type="number"
                :label="$t('label_essweb_leaveCancelReason_from_sequenceLabel')"
                isNotRequire
                maxlength="10"
                :rules="
                  $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
                "
                v-model="leaveCancelData.sequence"
              />
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <normalInputTextFiled
                :label="$t('label_essweb_leaveCancelReason_from_codeLabel')"
                maxlength="50"
                :rules="$GetRules(['_Require_Rules'], [null])"
                v-model="leaveCancelData.leave_reason_code"
              />
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <inputTextFiledMultiLang
                :bindData="leaveCancelData.leave_reason_description"
                maxlength="500"
                @change="
                  (valueArr) => {
                    leaveCancelData.leave_reason_description = valueArr;
                  }
                "
                :label="
                  $t('label_essweb_leaveCancelReason_from_descriptionLabel')
                "
              />
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <v-sheet class="text--secondary">{{
                $t("label_essweb_leaveCancelReason_from_remarkLabel")
              }}</v-sheet>
              <v-textarea
                rows="5"
                no-resize
                maxlength="500"
                filled
                dense
                counter="500"
                single-line
                v-model="leaveCancelData.remarks"
                name="input-7-4"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toNew" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main></template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newLeaveCancelReason",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      isChanged: false,
      leaveCancelData: {
        leave_reason_name: "",
        leave_reason_code: "",
        leave_reason_description: "",
        sequence: 1,
        remarks: "",
      },
    };
  },
  mounted() {
    // this.leaveCancelData.leave_reason_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.leaveCancelData.leave_reason_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
  },
  methods: {
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_cancel_reason",
        url: "/leave-cancellation-reason/add/",
        data: {
          leave_reason_name: this.$transCommonLangKey(
            this.leaveCancelData.leave_reason_name
          ),
          leave_reason_description: this.$transCommonLangKey(
            this.leaveCancelData.leave_reason_description
          ),
          leave_reason_code: this.leaveCancelData.leave_reason_code,
          sequence: this.leaveCancelData.sequence,
          remarks: this.leaveCancelData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
